import React from "react";
import { styled, alpha } from "@mui/material/styles";
import { Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ExcellIcon from "../../assets/images/Excell.png";
import { DownloadExcel } from "../../pages/MonthlyReport/DownloadExcel";
// import { DownloadExcel } from "../../sharedComponents/DownloadExcelSheet/DownloadExcel";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
       cursor: "pointer", 
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:hover": {
        backgroundColor: "transparent", // ✅ disables background color on hover
      },
      "&.Mui-focusVisible": {
        backgroundColor: "transparent", // ✅ disables focus background too
      },
      "&.Mui-selected": {
        backgroundColor: "transparent", // if selected
      },
      "&.Mui-selected:hover": {
        backgroundColor: "transparent", // if selected and hovered
      },
      "&:active": {
        backgroundColor: "transparent", // disables active color
      },
    },
  },
}));

const DownloadButtonWithMenu = ({ excelData, excelColumns, filename }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const downloadPdf = () => {
    handleClose();
  };

  return (
    <>
      <Button
        id="download-button"
        aria-controls={open ? "download-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        style={{ color: "#fff", background: "#00675d" }}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Download
      </Button>

      <StyledMenu
        id="download-menu"
        MenuListProps={{ "aria-labelledby": "download-button" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {/* <MenuItem onClick={downloadPdf} disableRipple>
          <Stack direction="row" alignItems="center" spacing={1}>
            <PictureAsPdfIcon style={{ color: "#000" }} />
            <Typography
              style={{ fontFamily: '"Open Sans", sans-serif', color: "#000" }}
            >
              Download pdf
            </Typography>
          </Stack>
        </MenuItem> */}

        <MenuItem disableRipple>
          <Stack direction="row" alignItems="center" spacing={1}>
            {/* <img
              src={ExcellIcon}
              alt="excel"
              style={{ height: 17, width: 17 }}
            /> */}
            <DownloadExcel
              data={excelData}
              columns={excelColumns}
              filename={filename}
            />
          </Stack>
        </MenuItem>
      </StyledMenu>
    </>
  );
};

export default DownloadButtonWithMenu;
